export default "__VITE_ASSET__41604cd3__"